<section class="flex flex-col items-center gap-6">
  <h1 class="text-4xl font-bold md:text-5xl">Careers at Capawesome</h1>
  <p class="max-w-3xl text-center text-xl">
    We are a global, fully remote team on a mission to build the best mobile
    SDKs and services for the modern mobile app ecosystem.
  </p>
</section>
